import './VideoDetectedClaimsSkeleton.css';

export default function VideoDetectedClaimsSkeleton() {
	return (
		<section id="video-detected-claims-skeleton" className="skeleton">
			<h3 className="skeleton-element" />
			<ul>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
				<li>
					<span>
						<strong>
							<span>--:--</span>
						</strong>
						<span className="skeleton-element" />
					</span>
				</li>
			</ul>
			<footer className="skeleton-element" />
		</section>
	);
}
